import type { ReactNode } from 'react'
import { useProductLink } from 'src/sdk/product/useProductLinkV2'
import { Link } from 'gatsby'

import type { Product } from '../../../types/product'
import type { ProductItem } from '../../../types/productItem'

interface CrossSellCardLinkProps {
  product: Product
  sku: ProductItem
  children: ReactNode
}

export function CrossSellCardLink({
  product,
  sku,
  children,
}: CrossSellCardLinkProps) {
  const shelfRef = `vitrine - Buy together${
    product?.sport ? ` - ${product?.sport}` : ''
  }`

  const productLink = useProductLink({
    product,
    currentSku: sku,
    index: 0,
    slug: product.linkText ?? '',
    shelfRef,
    ...(product?.slotId && { engine: 'dy' }),
  })

  return <Link to={productLink.to}>{children}</Link>
}
